var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlame = function SvgFlame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#131635",
    d: "M14.5 10.041c0 3.115-1.964 4.482-3.48 4.943-.325.098-.537-.27-.344-.542.66-.926 1.424-2.34 1.424-3.669 0-1.428-1.233-3.114-2.196-4.153-.22-.238-.604-.08-.616.24-.04 1.06-.211 2.48-.95 3.592a.313.313 0 0 1-.508.027c-.231-.285-.462-.638-.694-.916-.124-.15-.349-.152-.493-.02-.56.518-1.343 1.325-1.343 2.329 0 .68.27 1.394.575 1.968.168.316-.13.696-.453.531C4.085 13.686 2.5 12.3 2.5 10.041c0-2.303 3.233-5.494 4.467-8.509.195-.476.795-.7 1.213-.389 2.528 1.88 6.32 5.515 6.32 8.898"
  })));
};
export default SvgFlame;